import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Injector,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { FiImageSize } from '@fi-shared/types';
import { FiDateTimeFormatOptions } from '@fi-shared/utils';
import { IChecklistV2ReportParameterFilter } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report';
import { FiChecklist2ReportDialogsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-dialogs.service';
import { FiChecklist2AttachmentsBase } from '@fi-shared/checklist/fi-checklist2-report/components/shared/fi-checklist2-attachments-base';
import { FiChecklist2ReportType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';
import { Observable, Subject } from 'rxjs';

@Component({
    selector: 'fi-checklist-attachments-gallery-card',
    templateUrl: './checklist-attachments-gallery-card.component.html',
    styleUrls: ['./checklist-attachments-gallery-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-attachments-gallery-card' },
    standalone: false,
})
export class FiChecklistAttachmentsGalleryCard extends FiChecklist2AttachmentsBase implements OnInit {
    @Input({ required: true }) reportType: FiChecklist2ReportType;
    @Input({ required: true }) currentFilter: IChecklistV2ReportParameterFilter;
    @Input({ required: true }) reportParameterId: number;
    @Input({ required: true }) auditMode: boolean;
    @Input({ required: true }) answersChanged$: Observable<void>;
    @Output() onExpandChecklistAttachmentList = new EventEmitter<void>();

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    expandChecklistAttachmentList() {
        this.onExpandChecklistAttachmentList.emit();
    }

    searchAttachments(searchStr: string) {
        // implement search at backend in case of need
        /*this._searchStr = searchStr;
        if (!this._searchStr?.length) {
            this.filteredAttachments$.next(this.answersWithAttachments);
            return;
        }
        this.filteredAttachments$.next(this.filteredAttachments$.value.filter((attachment: IChecklist2ReportAnswer) => {
            return attachment.BusinessUnitName.toLowerCase().includes(this._searchStr.toLowerCase()) ||
                attachment.ChecklistName.toLowerCase().includes((this._searchStr.toLowerCase())) ||
                attachment.ChangedByProfile.FullName.toLowerCase().includes(this._searchStr.toLowerCase());
        }));*/
    }

    protected readonly FiDateTimeFormatOptions = FiDateTimeFormatOptions;
    protected readonly FiImageSize = FiImageSize;
}
